<template>
  <DxPopup
    v-if="currentQuest"
    :visible="visible"
    :title="currentQuest.name"
    :width="popupWidth"
    :height="'auto'"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-close-button="false"
    :wrapper-attr="{ class: 'reward-modal-wrapper' }"
    @update:visible="handleVisibilityChange"
  >
    <div class="reward-modal">
      <div class="reward-modal__icon">
        <TokenIcon />
      </div>
      <p
        v-if="currentQuest.valueProposition"
        class="reward-modal__value-proposition"
      >
        {{ currentQuest.valueProposition }}
      </p>
      <div class="reward-modal__reward">
        <span class="reward-modal__amount">
          {{ t("onboarding.rewardAmount", { amount: currentQuest.rewardAmount }) }}
        </span>
        <span class="reward-modal__note">
          {{ currentQuest.rewardType === "permanent" ? t("onboarding.permanentNote") : t("onboarding.expiryNote") }}
        </span>
      </div>
      <DxButton
        class="reward-modal__button"
        :text="t('onboarding.rewardModalButton')"
        type="default"
        styling-mode="contained"
        @click="handleClose"
      />
    </div>
  </DxPopup>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { DxPopup } from "devextreme-vue";
import DxButton from "devextreme-vue/button";
import { useOnboardingStore } from "../store/onboarding";
import { useGuidanceStore } from "../store/guidance";
import { useBreakpoints } from "../common/composables/useBreakpoints";
import TokenIcon from "../assets/icons/TokenIcon.vue";

const { t } = useI18n();
const onboardingStore = useOnboardingStore();
const guidanceStore = useGuidanceStore();
const { isMobile } = useBreakpoints();

const currentQuest = computed(() => onboardingStore.rewardModalQueue[0] ?? null);

// Не показываем поверх окна тура — очередь ждёт, пока тур не освободит экран
// (ТЕСТ ОНБОРДИНГ 2, «Общие правки»). Упрощение v1 относительно спеки «между
// шагами или после тура»: guidanceStore.isActive держится true весь тур
// целиком, а не только на модальных шагах — так что модалка фактически ждёт
// конца/паузы тура, а не каждого промежутка между шагами.
const visible = computed(() => currentQuest.value !== null && !guidanceStore.isActive);
const popupWidth = computed(() => (isMobile.value ? "calc(100vw - 32px)" : 380));

function handleClose() {
  onboardingStore.dismissCurrentRewardModal();
}

function handleVisibilityChange(nextVisible: boolean) {
  if (!nextVisible && !guidanceStore.isActive) {
    handleClose();
  }
}
</script>
